
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import './ChangerPage.css';

import {
  Link
} from "react-router-dom";


function ChangerPage() {
    return (
      <div className="container py-5 text-white" style={{ maxWidth: "1102px", margin: "0 auto" , fontFamily:  'Plus Jakarta Sans'}}>
      
        <img src="/changer2.webp" className="img-fluid-rounded-shadow" alt="Changer product page" />
        <style>{`
    .img-fluid-rounded-shadow {
      width: 1102px;
      height: 489px;
      display: block;
      margin: 0 auto;
      opacity: 0;
      transform: translateY(30px);
      animation: fadeInUp 1s ease-out forwards;
      animation-delay: 0.3s;
    }
  
    @keyframes fadeInUp {
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `}</style>
        <div style={{
      textAlign: "center",
      padding: "20px",
      fontSize: "24px",
      fontWeight: "400"
    }}>
      Exchange your bank, brand, and e-commerce loyalty points for real currency,<br />
      available for immediate spending.
    </div>
  
    <hr
    style={{
      
      borderTop: "1px solid #fff",
      marginTop: "20px",
      width: "1070px",
      margin: "40px auto 0 auto"
    }} ></hr>
  
  <section style={{ maxWidth: "1100px", margin: "0 auto", padding: "60px 20px" }}>
    <div style={{ display: "flex", gap: "40px", flexWrap: "nowrap", alignItems: "center" }}>
      
      {/* Görsel Alanı */}
      <div className="changer3-wrapper" style={{ flex: "1 1 50%", textAlign: "center" }}>
        <img className="changer3"
          src="/changer3.webp" 
          alt="Wallet Mockup" 
          style={{ 
            width: "100%", 
            height: "auto",
            borderRadius: "36px",
            
            display: "block",
            margin: "0 auto",
            
          }} 
        />
      </div>
  
      {/* Yazı Alanı */}
      <div style={{ flex: "1 1 50%", maxWidth: "653px", textAlign: "right" }}>
        <h2 className="how-changer-works" style={{ fontSize: "36px", fontWeight: "700", marginBottom: "12px", lineHeight: "28px" }}>
          How Changer Works?
        </h2>
        <p style={{ fontSize: "24px", color: "#9EABB8", marginBottom: "6px", lineHeight: "42px" }}>
          Instant Point Conversion at Checkout
        </p>
        <br />
        <p style={{ fontSize: "18px", color: "#fff", lineHeight: "28px", fontWeight: 400 }}>
          Changer seamlessly integrates with a network of leading banks, popular brands, and online stores.
          This powerful connection is the key to unlocking the value of your loyalty points exactly when you
          need them. Simply shop with businesses integrated with Changer. When you reach the payment stage,
          Changer instantly identifies your available, eligible points.
        </p>
      </div>
    </div>
  </section>
  
    <hr
    style={{
      
      borderTop: "1px solid #fff",
      marginTop: "20px",
      width: "1070px",
      margin: "40px auto 0 auto"
    }} ></hr>
      
      <section style={{ maxWidth: "1100px", margin: "0 auto", padding: "40px 20px" }}>
    <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "nowrap", gap: "32px" }}>
    <div style={{
        backgroundColor: "#121417",
        borderRadius: "12px",
        padding: "24px",
        width: "515px",
        
        textAlign: "left",
        boxSizing: "border-box"
      }}>
        <img src="/pexels2.jpg" alt="Icon" style={{ width: "100%", height: "258px", marginBottom: "9px", borderRadius: "13.55px", objectFit: "cover" }} />
        <h4 style={{ fontSize: "16px", fontWeight: "bold", color: "#FFF" }}>Increase Sales & Customer Loyalty</h4>
        <p style={{ fontSize: "14px", color: "#9EABB8", marginTop: "8px" }}>
          Partner with Changer to offer seamless point-to-cash conversion directly in your checkout flow. Drive higher sales conversions, deepen customer loyalty by adding real value to their points, increase average order value, and gain a competitive edge – all through simple integration with our network.
        </p>
      </div>
  
      <div style={{
        backgroundColor: "#121417",
        borderRadius: "12px",
        padding: "24px",
        width: "515px",
        textAlign: "left",
        boxSizing: "border-box"
      }}>
        <img src="/pexels1.jpg" alt="Icon" style={{ width: "100%", height: "258px", marginBottom: "16px", borderRadius: "13.55px", objectFit: "cover" }} />
        <h4 style={{ fontSize: "16px", fontWeight: "bold", color: "#FFF" }}>Your Points, Now Effortless Discounts</h4>
        <p style={{ fontSize: "14px", color: "#9EABB8", marginTop: "8px" }}>
          Stop letting points gather dust! With Changer integrated into your favorite stores and banks, you'll automatically see chances to convert points into cash right when you pay. Just shop as usual, and let the savings find you at checkout.
        </p>
      </div>
  
    
  
    </div>
  </section>
  
  <div className="keyyy" style={{ maxWidth: "1070px", margin: "0 auto", textAlign: "left", padding : "17px" }}>
    <h2 style={{ fontSize: "36px", fontWeight: "700", color: "#fff" }}>
      Key Advantages
    </h2>
    <br></br>
    <p style={{ fontSize: "14px", color: "#fff", maxWidth: "600px", fontWeight: "400", letterSpacing: "0px" }}>
      We provide tailored digital solutions across key areas to help telecom and banking institutions achieve their strategic goals.
    </p>
  </div>
  
  <br></br>
  
  <div style={{ display: "flex", justifyContent: "center" }}>
      
      <section className="section row"  style={{ display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
      gap: "24px",
      maxWidth: "1070px",
      margin: "0 auto"}}>
    {[
      {
        title: "Increase Customer Engagement",
        text: "Changer turns your loyalty points into a usable online balance, motivating customers to return to your brand more frequently rather than letting points sit idle or expire.",
        icon: <img src="1.webp" alt="icon" className="card-icon" />,
        background: `radial-gradient(circle at top left, #368DEA , transparent 35%),#1C2126`
      },
      {
        title: "Drive Online Sales",
        text: "Customers can apply their converted points to purchases on your online platforms or other Masterpass-supported sites, boosting transaction frequency and encouraging digital spending.",
        icon: <img src="1.webp" alt="icon" className="card-icon" />,
        background: `radial-gradient(circle at top left, #8A36EA, transparent 45%),#1C2126`
      },
      {
        title: "Simple Integration",
        text: "Our straightforward API ensures a quick setup, supported by our team, so you can focus on your business while we enable the tech.",
        icon: <img src="1.webp" alt="icon" className="card-icon" />,
        background: `radial-gradient(circle at top right,#FF58C5, transparent 45%),#1C2126`
      },
      {
        title: "Enhance Loyalty Program Value",
        text: "By offering a practical way to use points online, Changer makes your rewards program more appealing, strengthening customer loyalty and satisfaction.",
        icon: <img src="1.webp" alt="icon" className="card-icon" />,
        background: `radial-gradient(circle at top right, #EA4436, transparent 35%),#1C2126`
      }
    ].map((item, i) => (
      <div className="col-md-4 mb-4" key={i}>
        <div
          className="p-4 h-100 text-white shadow-lg true-style-card position-relative"
          style={{
            background: item.background,
            borderRadius: "10px",
            border: "1px solid #3D4754",
            width: "252px",
            height: "255px"
          }}
        >
          <div className="icon-visible text-start mb-3">
            {item.icon}
          </div>
          <h5 className="card-title text-start">{item.title}</h5>
          <p className="card-text text-start">{item.text}</p>
        </div>
      </div>
    ))}
  </section>
  </div>
  <style>{`
    .card-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 0.5rem;
    }
  
    .card-text {
      font-size: 14px;
      color: #ccc;
    }
  
    .card-icon {
      width: 24px;
      height: 24px;
    }
  `}</style>
   <hr
    style={{
      
      borderTop: "1px solid #fff",
      marginTop: "20px",
      width: "1070px",
      margin: "40px auto 0 auto"
    }} ></hr>
  <div style={{ maxWidth: "1070px", margin: "0 auto", padding: "40px 0" }}>
  
  {/* 1. Kısım: Yazı Sol - Görsel Sağ */}
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "60px" }}>
    <div className="teleefon" style={{ width: "50%", paddingRight: "24px" }}>
      <h4 style={{ fontSize: "22px", fontWeight: "700", color: "white", marginBottom: "12px" }}>
        How It Works for You
      </h4>
      <br></br>
      <p style={{ fontSize: "16px", color: "#fff" }}>
        As a Changer partner, your customers access our platform via wallets like Masterpass or DenizKartım. They view their points from your program, convert them into a spendable balance in real time, and use that balance for online purchases wherever Masterpass is accepted—ideally driving traffic back to your digital storefront. You gain increased engagement without managing the conversion process; Changer and Masterpass handle it securely and efficiently.
      </p>
    </div>
    <div className="telefon1" style={{ width: "50%", display: "flex", justifyContent: "flex-end" }}>
      <img src="telefon1.webp" alt="How it works" style={{ borderRadius: "21.28px", maxWidth: "438px", height: "322.74px" }} />
    </div>
  </div>
  
  <hr style={{ borderTop: "1px solid #fff", marginTop: "20px", width: "1070px", margin: "20px auto 0 auto" }} />
  <br /><br />
  
  {/* 2. Kısım: Görsel Sol - Yazı Sağ */}
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", textAlign: "right" }}>
    <div className="laptop4" style={{ width: "50%", display: "flex", justifyContent: "flex-start", paddingRight: "24px" }}>
      <img src="laptop4.webp" alt="Partner with Changer" style={{ borderRadius: "12px", maxWidth: "100%", height: "auto" }} />
    </div>
    <div className="laptop41" style={{ width: "50%", paddingLeft: "24px" }}>
      <h4 style={{ fontSize: "28px", fontWeight: "700", color: "#fff", lineHeight: "28px" }}>
        Why Partner with Changer?
      </h4>
      <br />
      <p style={{ fontSize: "16px", color: "#fff" }}>
        Every year, countless loyalty points go unused, representing lost opportunities for connection. Changer flips that script by making points a practical online spending option, keeping your brand relevant and active in customers’ minds. Our expanding network offers a vibrant ecosystem for growth. With Masterpass’s trusted security, your customers’ experience is safe and reliable, reflecting positively on your brand.
      </p>
    </div>
  </div>
  
  
  <hr style={{ borderTop: "1px solid #fff", marginTop: "20px", width: "1070px", margin: "20px auto 0 auto" }} />
  <br /><br />
  
  {/* 3. Kısım: Yazı Sol - Görsel Sağ */}
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    <div className="laptop31"style={{ width: "50%", paddingRight: "24px" }}>
      <h4 style={{ fontSize: "28px", fontWeight: "700", color: "white", marginBottom: "12px" }}>
        Things to Consider
      </h4>
      <br></br>
      <p style={{ fontSize: "16px", color: "#fff" }}>
        Partnering with Changer is a low-effort, high-impact decision. The integration is easy, but success hinges on promoting this benefit to your customers—something we’ll support you with. The balance isn’t cash; it’s a digital value for online use, so it’s best suited for partners with a strong e-commerce presence or a desire to grow one.
      </p>
    </div>
    <div className="laptop3"style={{ width: "50%", display: "flex", justifyContent: "flex-end" }}>
      <img src="laptop3.webp" alt="Things to consider" style={{ borderRadius: "20.86px", maxWidth: "438px", height: "399.76px" }} />
    </div>
  </div>
  
  </div>
  
  <hr style={{ borderTop: "1px solid #fff", marginTop: "20px", width: "1070px", margin: "40px auto 0 auto" }} />
  <br></br>
  <div
    style={{
      backgroundImage: "url('/changerlast.webp')", // Buraya kendi arka plan görselinin yolu
      backgroundSize: "cover",
      backgroundPosition: "center",
      paddingTop: "16px",
      paddingBottom: "16px",
      borderRadius: "20px",
      maxWidth: "1070px",
      height: "512px",
      display: "flex",
      margin: "0 auto",
      color: "#fff",
      alignItems: "center",
      justifyContent : "center"
    }}
  >
  <div
      style={{
        width: "848px",
        borderRadius: "40px",
        padding: "40px",
        backgroundColor: "rgba(255, 255, 255, 0.01)", // Beyaz ama çok şeffaf
        backdropFilter: "blur(1px)",
        WebkitBackdropFilter: "blur(2px)",
        color: "#fff",
        textAlign: "left"
      }}
    >
      <h2 style={{ fontSize: "48px", fontWeight: "700" }}>
        Let’s Grow Together
      </h2>
      <br></br>
      <p style={{ fontSize: "16px", lineHeight: "24px", letterSpacing: "0px", color: "#fff"}}>
        Changer isn’t just a platform—it’s a partnership that turns loyalty into opportunity.
        By joining us, you empower your customers to shop online with their points, boost your digital
        engagement, and elevate your brand’s appeal. Ready to take the next step? Check out our API
        details online or drop us a “Let’s grow together!” message. With Changer, your loyalty program
        becomes a bridge to stronger connections—let’s build it together!
      </p>
      <br></br>
      <Link to="/contactus" onClick={() => window.scrollTo(0, 0)}>
      <button
        style={{
          backgroundColor: "#2563eb",
          color: "#fff",
          padding: "12px 24px",
          border: "none",
          borderRadius: "20px",
          fontSize: "14px",
          fontWeight: "500",
          cursor: "pointer"
        }}
      >
        Let’s Grow Together
      </button>
      </Link>
    </div>
  </div>
  
      </div>
    );
  }
  
  export default ChangerPage;